import api from "../utils/api";

export const accountAddInfo = (body)  => {
  api.caseInfo
    .accountAddInfo(null, body)
    .then(res => {
      // console.log(res);
    })
    .catch(err => {
      // console.dir(err);
    });
};